export enum RoutePaths {
  BASE_PATH = '/',
  SET_UP_PASSWORD = '/set-up-password/:userId',
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  PATIENTS = '/patients',
  PATIENT_CASE = '/patients/:patientId?',
  DASHBOARD = '/dashboard', // rename
  TASKS = '/tasks',
  NOT_EXISTING_ROUTES = '*',
}
